import { Injectable } from '@angular/core';
import { AuthMessages } from '@app/auth/auth.messages';
import { ChangePasswordDto } from '@app/models/user/change-password.dto';
import { User } from '@app/models/user/user.model';
import { UserAPIService } from '@app/shared/api/user.api.service';
import { NotifyUtils } from '@app/shared/utils/notify.utils';
import { SecuritySettingsAPIService } from '../../api/security-settings/security-settings-api.service';
import { firstValueFrom } from 'rxjs';
import { InFlightRegistry } from '@app/shared/utils/in-flight-registry';

const WRITE_KEY = 'write';

@Injectable({
  providedIn: 'root'
})
export class SecuritySettingsBusinessService {

  // A write already in flight coalesces a duplicate call onto the same promise (see InFlightRegistry)
  // rather than rejecting it, which previously surfaced as an unhandled rejection (Sentry FRONTEND-3HT).
  private writes = new InFlightRegistry();

  constructor(
    private securitySettingsAPIService: SecuritySettingsAPIService,
    private userAPIService: UserAPIService,
    private notifyUtils: NotifyUtils
  ) { }

  updatePassword(changePasswordDto: ChangePasswordDto): Promise<User> {
    return this.writes.run(WRITE_KEY, () =>
      firstValueFrom(this.securitySettingsAPIService.updatePassword(changePasswordDto))
        .then(res => {
          this.notifyUtils.notify(AuthMessages.SUCCESS_CHANGE_PASSWORD);
          firstValueFrom(this.userAPIService.getUserInit()).then();
          return res;
        })
    );
  }
}
